// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"da3466b7","222":"d61330a2","725":"28cf1028","773":"e0e58a28","787":"faeaf909","791":"69cfa9c1"}[chunkId] + ".chunk.js";
};